import { Injectable } from "@angular/core";
import English from "../../locale/english";
import Chinese from "../../locale/chinese";
import { LanguageMeta } from "../../Models/language-models.interface";
import { Profile } from "../../Models/profile.interface";
import { BehaviorSubject } from "rxjs";
import { AngularFirestore } from "@angular/fire/firestore";
import {
  FlatTranslation,
  Translation,
} from "src/app/Models/translation.interface";
import { Lesson } from "src/app/Models/lessons.interface";

@Injectable({
  providedIn: "root",
})
export class LanguageSwitchService {
  currentLanguage: LanguageMeta;
  config: BehaviorSubject<FlatTranslation> = new BehaviorSubject(English);

  // for lesson editing
  lessons: BehaviorSubject<Record<string, Lesson>> = new BehaviorSubject(null);
  languages: LanguageMeta[] = [];

  constructor(private afs: AngularFirestore) {
    this.configureDefaultLanguage();
    this.afs
      .collection<LanguageMeta>("Languages")
      .valueChanges()
      .subscribe({
        next: (languages) => {
          this.languages = languages;
          console.log(languages);
        },
      });
  }

  getCurrentSiteLangauage = () => {
    return this.config.value;
  };

  configureDefaultLanguage = () => {
    this.setLanguageTo("en");
  };

  configureProfileLanguagePreference = async (profile: Profile) => {
    const code = profile?.preferences?.language?.code;
    if (code) {
      if (code === this.currentLanguage.code) return;
      try {
        this.setLanguageTo(code);
      } catch (e) {
        throw new Error(`Error loading translation data for ${code}`);
      }
    } else {
      this.configureDefaultLanguage();
    }
  };

  private getConfig = async (lang: string) => {
    const content = {} as Translation;
    const translationSnapshot = await this.afs
      .collection("Languages")
      .doc(lang)
      .collection<Translation>("Config")
      .get()
      .toPromise();
    translationSnapshot.docs.forEach((doc) => {
      content[doc.id] = doc.data();
    });
    return content;
  };

  overrideLanguageConfig = (config: Translation) => {
    const flatConfig = this.flattenConfig(config);
    this.config.next(flatConfig);
  };

  private flattenConfig = (config: Translation) => {
    // Start with bundled English defaults so missing remote keys (e.g. questionsRoot)
    // do not become undefined at runtime.
    let con = { ...English };
    for (let key in config) {
      con = { ...con, ...config[key] };
    }
    return con as FlatTranslation;
  };

  overrideLessonsTranslations = (lessons: Record<string, Lesson>) => {
    this.lessons.next(lessons);
  };

  private getLanguageFor = async (code: string) => {
    const meta = await this.afs
      .collection<LanguageMeta>("Languages")
      .doc(code)
      .valueChanges()
      .take(1)
      .toPromise();

    const config = await this.getConfig(code);
    return {
      meta,
      config,
    };
  };

  private setLanguageTo = async (code: string) => {
    const { meta, config } = await this.getLanguageFor(code);
    this.currentLanguage = meta;
    this.overrideLanguageConfig(config);
  };

  setLanguage = async (code: string) => {};
}
